// extracted by mini-css-extract-plugin
export var content = "style-mod--content--1834f";
export var image = "style-mod--image--7e6c9";
export var mainContainer = "style-mod--main-container--aadf9";
export var reverse = "style-mod--reverse--8c464";
export var richTextWrapper = "style-mod--rich-text-wrapper--65525";
export var title = "style-mod--title--630a2";